/**
 * Язык интерфейса (CC §13.1, экран S-05).
 *
 * В V1 сборка содержит только русский: набор языков определяется продуктом
 * (CC §13.1, строка «V1»). Значение всё равно живёт в `Settings.locale` и
 * синхронизируется между устройствами — экран показывает его честно, а не
 * прячет за «языка нет».
 *
 * Разметка обязана объявлять язык страницы (§11.3 п. 11): `<html lang>`
 * следует за `locale`, иначе программа чтения с экрана произносит русский
 * текст английскими правилами.
 */

export interface LocaleOption {
  /** Значение для `PATCH /me/settings` и заголовка `Accept-Language`. */
  value: string
  label: string
}

/** Языки, доступные в этой сборке. */
export const AVAILABLE_LOCALES: readonly LocaleOption[] = [{ value: 'ru', label: 'Русский' }]

export const DEFAULT_LOCALE = 'ru'

/**
 * Приводит значение сервера к доступному в сборке.
 *
 * S-05, «Частичные данные»: неизвестный `locale` показывается как ближайший
 * доступный, без ошибки, — сервер может знать языки, которых в сборке нет.
 */
export function resolveLocale(raw: string | null | undefined): string {
  if (!raw) return DEFAULT_LOCALE

  const normalized = raw.toLowerCase()
  const exact = AVAILABLE_LOCALES.find((option) => option.value === normalized)
  if (exact) return exact.value

  // `ru-RU` → `ru`: контракт допускает и региональные варианты.
  const base = normalized.split('-')[0] ?? ''
  const byBase = AVAILABLE_LOCALES.find((option) => option.value === base)
  return byBase?.value ?? DEFAULT_LOCALE
}

/** §11.3 п. 11: смена языка обновляет атрибут. */
export function applyDocumentLanguage(locale: string): void {
  document.documentElement.setAttribute('lang', resolveLocale(locale))
}
